<template>
  <el-dialog
    :title='`${isCreate ? "新增" : "修改"}信息`'
    :visible.sync="visible"
    @closed="closed"
    custom-class="detail-dialog"
  >
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item label="标题" prop="title">
        <el-select
          v-model="form.title"
          filterable
          allow-create
          clearable
          placeholder="请填写标题">
          <el-option
            v-for="item in titleOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容" prop="context">
        <el-input v-model="form.context" type="textarea" :rows="1" placeholder="请填写内容" clearable></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请填写备注" clearable></el-input>
      </el-form-item>
      <el-form-item label="上传文件" prop="uploadFile">
        <el-upload
          ref="uploadFile"
          action
          :auto-upload="false"
          :on-change="(res, file) => onChange(res, file)"
          >
          <el-button size="mini">上传文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as utils from '@/utils'

export default {
  props: ['value'],
  data() {
    return {
      isCreate: true,
      rules: {
        title: { required: true, message: '请填写标题' },
        context: { required: true, message: '请添加内容' }
      },
      visible: false,
      form: {},
      titleOptions: [
        { id: '11', name: '合同启动时间' },
        { id: '47', name: '合同终止时间' },
        { id: '83', name: '启动时间' },
        { id: '211', name: '结算单价' },
        { id: '570', name: '考核指标' },
        { id: '913', name: '项目评估' },
        { id: '115', name: '目前运作情况同步' },
        { id: '652', name: '反馈周期' }
      ]
    }
  },
  methods: {
    onChange(res, file) {
      this.form.uploadFile = res.raw
    },
    closed() {
      this.$emit('input', undefined)
    },
    submit() {
      // 自定义部分
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (!this.isCreate) {
            this.form.selfid = this.form.detailid
          }
          const data = utils.objectToFormdata(Object.assign(this.form, { aboutid: this.$route.query.id, type: 'project' }))
          this.$axios.post('/api/allmessage/adddetail', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(res => {
            if (res.data.status === 'success') {
              this.visible = false
              this.$parent.reload('detail')
            }
          })
        }
      })
    }
  },
  watch: {
    value(val) {
      if (val !== undefined) {
        this.visible = true
        if (JSON.stringify(val) === '{}') {
          this.isCreate = true
          this.form = {}
        } else {
          this.form = utils.cloneDeep(val)
          this.isCreate = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
.detail-dialog {
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
